export default "__VITE_ASSET__D$o8P_5g__"